(function () {
  var html = document.documentElement;
  var isCarvela =
    html.dataset.isCarvelaBrand === 'true' ||
    html.dataset.brand === 'carvela' ||
    /carvela/i.test(window.location.hostname);

  window.__brandFlags__ = window.__brandFlags__ || {};
  window.__brandFlags__.isCarvela = isCarvela;

  window.CarvelaBrand = window.CarvelaBrand || {};
  window.CarvelaBrand.isEnabled = function () {
    return isCarvela;
  };
  window.CarvelaBrand.getCartConvertedSizePrefix = function (usSize) {
    if (!isCarvela || !usSize) return '';
    return String(usSize) + '/';
  };

  document.addEventListener('DOMContentLoaded', function () {
    if (!isCarvela) return;

    var normalizeQueued = false;

    function scheduleNormalizeCarvelaMiniCartSizes() {
      if (normalizeQueued) return;
      normalizeQueued = true;
      window.requestAnimationFrame(function () {
        normalizeQueued = false;
        normalizeCarvelaMiniCartSizes();
      });
    }

    function normalizeCarvelaMiniCartSizes() {
      if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active === 'AUD') return;

      var sizeNodes = document.querySelectorAll('cart-drawer.drawer--kg .kg-minibag-size p');

      sizeNodes.forEach(function (node) {
        var raw = (node.textContent || '').trim();
        var match = raw.match(/^([0-9]+(?:\.[0-9]+)?)\s*\/\s*([0-9]+(?:\.[0-9]+)?)$/);
        if (!match) return;

        var left = parseFloat(match[1]);
        var right = parseFloat(match[2]);
        if (!Number.isFinite(left) || !Number.isFinite(right)) return;

        var normalized = left > right ? match[2] + '/' + match[1] : match[1] + '/' + match[2];
        if (raw === normalized) return;

        node.textContent = normalized;
      });
    }

    scheduleNormalizeCarvelaMiniCartSizes();
    document.addEventListener('cart:updated', function () {
      setTimeout(scheduleNormalizeCarvelaMiniCartSizes, 0);
    });
    document.addEventListener('cart-drawer:open', scheduleNormalizeCarvelaMiniCartSizes);

    // Carvela cart-page actions emit `cart-update`; bridge that into `cart:updated`
    // with fresh cart JSON so minicart icon/drawer listeners receive up-to-date data.
    var cartUpdateBridgeQueued = false;
    var cartUpdateBridgeTimer = null;

    function bridgeCartUpdateToCartUpdated() {
      if (cartUpdateBridgeQueued) return;
      cartUpdateBridgeQueued = true;

      if (cartUpdateBridgeTimer) {
        clearTimeout(cartUpdateBridgeTimer);
      }

      cartUpdateBridgeTimer = setTimeout(function () {
        var shopifyRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        var cartJsonUrl = (shopifyRoot === '/' ? '/' : shopifyRoot) + 'cart.js';

        function updateCartIconCount(cart) {
          var itemCount = Number((cart && cart.item_count) || 0);

          var legacyBubble = document.querySelector('#cart-icon-bubble .cart-count-bubble');
          if (legacyBubble) {
            var countNode = legacyBubble.querySelector('[aria-hidden="true"]') || legacyBubble.querySelector('span');
            if (countNode) {
              countNode.textContent = String(itemCount);
            }
            var srNode = legacyBubble.querySelector('.visually-hidden');
            if (srNode) {
              srNode.textContent = itemCount + (itemCount === 1 ? ' item' : ' items');
            }
          }

          var alpineCount = document.getElementById('cart-icon-count');
          if (alpineCount) {
            alpineCount.textContent = String(itemCount);
            alpineCount.classList.toggle('hidden', itemCount === 0);
          }
        }

        function refreshDrawerMarkupOnly() {
          var cartDrawer = document.querySelector('cart-drawer');
          if (!cartDrawer) return Promise.resolve();

          var cartDrawerSectionId =
            cartDrawer && typeof cartDrawer.getCartDrawerSectionId === 'function'
              ? cartDrawer.getCartDrawerSectionId()
              : 'cart-drawer';

          var sectionUrl = (shopifyRoot === '/' ? '/' : shopifyRoot) + 'cart?sections=' + encodeURIComponent(cartDrawerSectionId);

          return fetch(sectionUrl, { credentials: 'same-origin', cache: 'no-store' })
            .then(function (response) {
              return response.json();
            })
            .then(function (sections) {
              var sectionHtml = sections && (sections[cartDrawerSectionId] || sections['cart-drawer']);
              if (!sectionHtml) return;

              var newCartDrawer = new DOMParser().parseFromString(sectionHtml, 'text/html').querySelector('cart-drawer');
              if (!newCartDrawer) return;

              cartDrawer.innerHTML = newCartDrawer.innerHTML;
              var overlay = cartDrawer.querySelector('#CartDrawer-Overlay');
              if (overlay && typeof cartDrawer.close === 'function') {
                overlay.addEventListener('click', cartDrawer.close.bind(cartDrawer));
              }
            });
        }

        Promise.all([
          refreshDrawerMarkupOnly().catch(function () {}),
          fetch(cartJsonUrl, { credentials: 'same-origin', cache: 'no-store' })
            .then(function (response) {
              return response.json();
            })
            .catch(function () {
              return null;
            }),
        ])
          .then(function (results) {
            var cart = results[1];
            if (cart) {
              updateCartIconCount(cart);
              document.dispatchEvent(
                new CustomEvent('cart:updated', {
                  detail: { cart: cart, source: 'alp-cart-store' },
                })
              );
            }
          })
          .finally(function () {
            setTimeout(scheduleNormalizeCarvelaMiniCartSizes, 0);
            cartUpdateBridgeQueued = false;
          });
      }, 80);
    }

    document.addEventListener('cart-update', bridgeCartUpdateToCartUpdated);

    var productMeta = document.querySelector('.product-details .product-meta');
    var mobileQuery = window.matchMedia('(max-width: 1024px)');

    if (productMeta) {
      var childBlocks = Array.from(productMeta.children);
      var buyButtonBlock = childBlocks.find(function (el) {
        return el.classList && el.classList.contains('product-buy-button');
      });
      var optionsBlock = childBlocks.find(function (el) {
        return el.classList && el.classList.contains('product-options');
      });

      if (buyButtonBlock && optionsBlock) {
        function syncCarvelaOptionsPlacement() {
          if (mobileQuery.matches) {
            if (buyButtonBlock.nextElementSibling !== optionsBlock) {
              buyButtonBlock.insertAdjacentElement('afterend', optionsBlock);
            }
            return;
          }

          if (buyButtonBlock.previousElementSibling !== optionsBlock) {
            buyButtonBlock.parentNode.insertBefore(optionsBlock, buyButtonBlock);
          }
        }

        syncCarvelaOptionsPlacement();

        if (typeof mobileQuery.addEventListener === 'function') {
          mobileQuery.addEventListener('change', syncCarvelaOptionsPlacement);
        } else if (typeof mobileQuery.addListener === 'function') {
          mobileQuery.addListener(syncCarvelaOptionsPlacement);
        }
      }
    }

    function getLocalSizeConversionData() {
      var data = window.kgLocalSizeConversionJson || [];

      if (typeof data === 'string') {
        try {
          data = JSON.parse(data);
        } catch (e) {
          data = [];
        }
      }

      return Array.isArray(data) ? data : [];
    }

    function getUKSizeDisplay(optionItem) {
      var euValue = (optionItem.dataset.value || '').trim();
      var productTags = (optionItem.dataset.productTags || '')
        .split(',')
        .map(function (tag) { return tag.trim().toUpperCase(); })
        .filter(Boolean);
      var entry = getLocalSizeConversionData().find(function (item) {
        var mappingTags = String(item.product_tags || '')
          .split(',')
          .map(function (tag) { return tag.trim().toUpperCase(); })
          .filter(Boolean);

        return String(item.size || '').trim() === euValue
          && mappingTags.some(function (tag) { return productTags.indexOf(tag) !== -1; });
      });

      return entry && entry.uk_size ? String(entry.uk_size) : euValue;
    }

    function getUSSizeDisplay(optionItem) {
      var conversionText = optionItem.dataset.sizeConversion || '';
      var conversionMatch = conversionText.match(/US\s*([0-9]+(?:\.[0-9]+)?)/i);

      if (conversionMatch && conversionMatch[1]) {
        return conversionMatch[1];
      }

      var convertedSpan = optionItem.querySelector('.converted-size');
      if (convertedSpan) {
        var fallbackMatch = (convertedSpan.textContent || '').match(/US\s*([0-9]+(?:\.[0-9]+)?)/i);
        if (fallbackMatch && fallbackMatch[1]) {
          return fallbackMatch[1];
        }
      }

      return (optionItem.dataset.value || '').trim();
    }

    function applyCarvelaSizeSystem(optionSet, sizeSystem) {
      optionSet.dataset.sizeSystem = sizeSystem;

      optionSet.querySelectorAll('.carvela-size-system').forEach(function (button) {
        var isActive = button.dataset.sizeSystem === sizeSystem;
        button.classList.toggle('active', isActive);
        button.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      optionSet.querySelectorAll('.select-other-options li[data-value]').forEach(function (optionItem) {
        var label = optionItem.querySelector('.size-display-value');
        if (!label) return;

        var euValue = (optionItem.dataset.value || '').trim();
        if (sizeSystem === 'us') {
          label.textContent = getUSSizeDisplay(optionItem);
        } else if (sizeSystem === 'uk') {
          label.textContent = getUKSizeDisplay(optionItem);
        } else {
          label.textContent = euValue;
        }
      });
    }

    document.querySelectorAll('.option-set--carvela-size').forEach(function (optionSet) {
      var systemButtons = optionSet.querySelectorAll('.carvela-size-system[data-size-system]');

      systemButtons.forEach(function (button) {
        button.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          applyCarvelaSizeSystem(optionSet, this.dataset.sizeSystem || 'uk');
          setTimeout(syncCarvelaPriceDisplay, 0);
        });
      });

      var defaultSizeSystem = optionSet.querySelector('[data-size-system="us"]')
        ? 'us'
        : optionSet.querySelector('[data-size-system="eu"]')
          ? 'eu'
          : 'uk';
      applyCarvelaSizeSystem(optionSet, defaultSizeSystem);

      setTimeout(function () {
        applyCarvelaSizeSystem(optionSet, optionSet.dataset.sizeSystem || defaultSizeSystem);
      }, 0);
    });

    function formatCarvelaPrice(price) {
      var amount = price / 100;
      return new Intl.NumberFormat(window.Shopify.locale + '-' + window.Shopify.country, {
        style: 'currency',
        currency: window.Shopify.currency.active,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(amount);
    }

    function syncCarvelaPriceDisplay() {
      if (typeof variants === 'undefined') return;

      var variantsData;
      try {
        variantsData = JSON.parse(variants);
      } catch (e) {
        return;
      }

      var variantIdInput = document.querySelector('.product-meta input[name="id"]');
      var priceCurrentEl = document.querySelector('.product-price .product-price--current');
      var priceCompareEl = document.querySelector('.product-price .product-price--compare');
      var discountBadgeEl = document.querySelector('.product-discount-badge');

      if (!variantIdInput || !priceCurrentEl) return;

      var selectedVariantId = String(variantIdInput.value || '');
      var variant = variantsData.find(function (v) {
        return String(v.id) === selectedVariantId;
      });

      if (!variant) return;

      priceCurrentEl.textContent = formatCarvelaPrice(variant.price);

      if (priceCompareEl) {
        if (variant.compare_at_price > variant.price) {
          priceCompareEl.textContent = formatCarvelaPrice(variant.compare_at_price);
          priceCompareEl.style.display = 'inline';
        } else {
          priceCompareEl.style.display = 'none';
        }
      }

      if (discountBadgeEl) {
        if (variant.compare_at_price > variant.price) {
          var discount = Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100);
          discountBadgeEl.textContent = discount + '% Off';
          discountBadgeEl.style.display = 'block';
        } else {
          discountBadgeEl.style.display = 'none';
        }
      }
    }

    document.querySelectorAll('.select-other-options li').forEach(function (option) {
      option.addEventListener('click', function () {
        setTimeout(syncCarvelaPriceDisplay, 0);
      });
    });

    setTimeout(syncCarvelaPriceDisplay, 0);
  });
})();
